import { gql } from '@apollo/client';

export const USER_LOGIN = gql`
  mutation Login($loginPayload: LoginRequest!) {
    login(loginPayload: $loginPayload) {
      token {
        accessToken
        refreshToken
      }
      session {
        userId
        accountId
        cynergyId
        practitionerId
        staffRelationId
        organizationId
        locationId
        locationName
        availableLocations {
          assignment_id
          location_id
          location {
            alias
          }
        }
        email
        userType
        phone
        lastName
        firstName
        username
        initials
        authnetProfileId
        address {
          addressLine1
          addressLine2
          city
          state
          zip
          formattedAddress
          placeId
          isDefault
        }
        defaultPage
        firstLogin
        twoFactorEnabled
        twoFactorMethod
        photo
      }
      permissions
      errors {
        path
        message
      }
    }
  }
`;

